import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, RendererStyleFlags2 } from '@angular/core';
import { CartItemContext, OrderEntry } from '@spartacus/cart/base/root';
import { SpartacusCartItemComponent } from '../cart-item/cart-item.component';
import { CartItemContextSource } from '@spartacus/cart/base/components';
import { WindowRef } from '@spartacus/core';
import { NavigationEnd, Params, Router } from "@angular/router";
import { transformNameToUrl } from "../../../../shared/helpers/transform-name-to-url";
import { Subscription, tap } from 'rxjs';
import { GenServiceProductType } from 'src/app/generac/enums/service-product-type';
import { GenGoogleAnalyticsService } from 'src/app/generac/services/google-analytics.service';
import { GenSubscriptionProduct } from 'src/app/generac/models/subscription.model';

@Component({
  selector: '[gen-cart-item-list-row], gen-cart-item-list-row',
  templateUrl: './cart-item-list-row.component.html',
  providers: [
    CartItemContextSource,
    { provide: CartItemContext, useExisting: CartItemContextSource },
  ],
  standalone: false
})
export class GenCartItemListRowComponent extends SpartacusCartItemComponent {
  @ViewChild('promotions', { read: ElementRef }) promotions: ElementRef;
  @ViewChild('noReturnWarning', { read: ElementRef }) noReturnWarning: ElementRef;
  @ViewChild('materialNote', { read: ElementRef }) materialNote: ElementRef;
  @ViewChild('consumerDetailsSection', { read: ElementRef }) consumerDetailsSection: ElementRef;
  @ViewChild('cartItemInfo', { read: ElementRef }) cartItemInfo: ElementRef;
  @ViewChild('atestationDataRestrictionMessage', { read: ElementRef }) atestationDataRestrictionMessage: ElementRef;

  public consumerFormTopMargin: string;

  @Input() bundleId: string;
  @Input() maxItemsAllowed: number;
  @Input() isBundleItem: boolean;
  @Input() isBundleCollapsed: boolean;
  @Output() onBundleCollapse = new EventEmitter<boolean>();

  transformNameToUrl = transformNameToUrl;
  isSubscription: boolean;
  isReviewOrder: boolean;
  isCartPage: boolean;
  isServicePartsEnabled: boolean = false;
  sppFormValue: any;
  isConsumerDetailsSectionExpanded: boolean = false;
  queryParams: Params;
  mobileOnly: boolean = false;
  protected subscriptions = new Subscription();

  constructor(
    protected override cartItemContextSource: CartItemContextSource,
    protected winRef: WindowRef,
    protected googleAnalyticsService: GenGoogleAnalyticsService,
    private router: Router,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    super(cartItemContextSource);
    this.isReviewOrder = this.winRef.location.href.includes('review-order') || this.winRef.location.href.includes('order-confirmation');
    this.isCartPage = this.winRef.location.href.includes('cart');
    this.isServicePartsEnabled = JSON.parse(this.winRef.localStorage.getItem('isServicePartsEnabled'));
    this.queryParams = this.router.routerState.snapshot.root.queryParams;
    this.subscriptions.add(
      this.cartItemContextSource.item$.pipe(
        tap(item => {
          this.isSubscription = Object.values(GenServiceProductType).includes((item?.product as GenSubscriptionProduct).serviceProductType);
          this.sppFormValue = item?.sppFormValue ? JSON.parse(item?.sppFormValue) : item?.sppFormValue;
          this.isConsumerDetailsSectionExpanded = this.queryParams['sppFormEditForEntry'] == item.entryNumber || this.isSppFormIncomplete();
        })
      ).subscribe()
    )

    this.subscriptions.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd && event.url.indexOf('expandSppForm=true') > -1) {
          this.queryParams = this.router.routerState.snapshot.root.queryParams;
          this.isConsumerDetailsSectionExpanded = this.queryParams['sppFormEditForEntry'] == this.item.entryNumber || this.isSppFormIncomplete();
        }
      })
    )
  }

  isSppFormIncomplete(): boolean {
    const isExpanded = this.queryParams['expandSppForm'] === 'true';

    const hasIncompleteFields = (formGroup: any) =>
      formGroup.fields.some((field: any) =>
        field.required && (!field.value || field.value.length < 1)
      );

    if (Array.isArray(this.sppFormValue)) {
      return this.sppFormValue.some(hasIncompleteFields);
    }

    return isExpanded && (!this.sppFormValue || hasIncompleteFields(this.sppFormValue));
  }

  isBuilderSpp(): boolean {
    return Array.isArray(this.sppFormValue) ? this.sppFormValue.some((group: any) => group.fields?.some((field: any) => field.code === 'builderName')) : this.sppFormValue?.fields?.some((field: any) => field.code === 'builderName');
  }

  onResize(hasSkipCondition?: boolean) {
    if (hasSkipCondition) {
      return;
    }

    this.mobileOnly = this.winRef.nativeWindow.innerWidth < 992;
    this.consumerFormTopMargin = `${(this.cartItemInfo?.nativeElement?.clientHeight ?? 0) + 8}px`;

    const promotionsEl = this.promotions?.nativeElement;
    const noReturnWarningElHeight = this.noReturnWarning?.nativeElement?.clientHeight || 0;
    const materialNoteElHeight = this.materialNote?.nativeElement?.clientHeight || 0;
    const consumerDetailsSectionElHeight = this.isConsumerDetailsSectionExpanded ? (this.consumerDetailsSection?.nativeElement?.firstChild?.clientHeight + 22) : 0;
    const atestationDataRestrictionMessageHeight = this.atestationDataRestrictionMessage?.nativeElement?.clientHeight || 0;


    const totalBottomPadding =
      (promotionsEl?.firstChild?.clientHeight || 0) + noReturnWarningElHeight + materialNoteElHeight +
      consumerDetailsSectionElHeight + atestationDataRestrictionMessageHeight;

    this.el.nativeElement.querySelectorAll('td')
      .forEach((item: HTMLElement, index: number, items: HTMLElement[]) => {
        const isLast = index === items.length - 1;

        if (this.mobileOnly && !isLast) {
          this.renderer.removeStyle(item, 'padding-bottom');
        }
        else {
          if (promotionsEl) {
            this.renderer.setStyle(
              promotionsEl.firstChild,
              'bottom',
              `${noReturnWarningElHeight + materialNoteElHeight + consumerDetailsSectionElHeight + atestationDataRestrictionMessageHeight}px`,
              RendererStyleFlags2.Important
            );
          }

          if (atestationDataRestrictionMessageHeight && noReturnWarningElHeight) {
            this.renderer.setStyle(
              this.atestationDataRestrictionMessage.nativeElement,
              'bottom',
              `0px`,
              RendererStyleFlags2.Important
            );
            this.renderer.setStyle(
              this.noReturnWarning.nativeElement,
              'bottom',
              `${atestationDataRestrictionMessageHeight}px`,
              RendererStyleFlags2.Important
            );
          }

          this.renderer.setStyle(
            item,
            'padding-bottom',
            `${totalBottomPadding + 11}px`,
            RendererStyleFlags2.Important
          );
        }
      });
  }

  onExpandToggle() {
    this.isBundleCollapsed = !this.isBundleCollapsed;
    this.onBundleCollapse.emit(this.isBundleCollapsed);
  }

  navigateToProduct() {
    this.router.navigate(['product', this.item.product.code, this.transformNameToUrl(this.item.product.name)]);
  }

  removeEntry(item: OrderEntry) {
    const product = {
      ...item.product,
      price: item.basePrice,
    }
    this.googleAnalyticsService.sendGaEvent('remove_from_cart', {
      currency: item.totalPrice.currencyIso,
      value: item.totalPrice.value,
      items: [this.googleAnalyticsService.mapProductToGaItem(product, 0, item.quantity)]
    });
    this.quantityControl.setValue(0);
    this.quantityControl.markAsDirty();
  }

  expandConsumerDetailsSection(): void {
    this.isConsumerDetailsSectionExpanded = !this.isConsumerDetailsSectionExpanded;
    this.onResize();
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
